import { observer } from 'mobx-react';
import ModalStore from '../../../../../../Modal/Store';
import { LearningCollectionResource } from '../../../../../Types';
import InviteParticipantStore from '../../Store';
import { SelectParticipantsState } from '../../Types';
import ModalContent from './ReadyModal/Body/ModalContent';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionResource: LearningCollectionResource;
  state: SelectParticipantsState;
}

function SelectParticipantsModal({ modalStore, store, learningCollectionResource, state }: Props) {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <ModalContent
          store={store}
          learningCollectionResource={learningCollectionResource}
          modalStore={modalStore}
          state={state}
        />
      );
  }
}

export default observer(SelectParticipantsModal);
